"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = require("react");
var _tracker = require("../tracker");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var PulseConfigurator = function PulseConfigurator(_ref) {
  var _ref$providerId = _ref.providerId,
    providerId = _ref$providerId === void 0 ? 'blocket-temp' : _ref$providerId,
    author = _ref.author,
    environment = _ref.environment,
    applicationName = _ref.applicationName,
    applicationVersion = _ref.applicationVersion,
    blocketApiUrl = _ref.blocketApiUrl,
    userId = _ref.userId;
  (0, _react.useEffect)(function () {
    (0, _tracker.setup)(providerId, author, environment, applicationName, applicationVersion, blocketApiUrl, userId);
  }, [providerId, author, environment, applicationName, applicationVersion, blocketApiUrl, userId]);
  return null;
};
PulseConfigurator.propTypes = {
  providerId: _propTypes["default"].string,
  author: _propTypes["default"].string,
  applicationName: _propTypes["default"].string.isRequired,
  applicationVersion: _propTypes["default"].string.isRequired,
  environment: _propTypes["default"].oneOf(['development', 'qa', 'production']),
  blocketApiUrl: _propTypes["default"].string,
  userId: _propTypes["default"].string
};
var _default = exports["default"] = PulseConfigurator;
//# sourceMappingURL=PulseConfigurator.js.map